<template>
  <van-overlay :show="show" :lock-scroll="false" @click="show = false">
    <div class="wrapper flex-col" @click.stop>
      <div
        class="dialog-main dialog-notice"
        style="animation-duration: 0.3s; border-radius: 0.625rem"
      >
        <div class="purple-notice h-full overflow-auto box-border p-[20px] pt-[30px]">
          <div class="grid grid-cols-5 gap-[15px] box-border text-[12px] w-full">
            <div
              v-for="(item, index) in applist"
              :key="index"
              class="w-[55px] flex items-center justify-center flex-col text-[#fff]"
              @click="handelUrl(item)"
            >
              <img class="w-full mb-[5px] rounded-[10px]" v-lazy="item.logo" alt="" />
              <div class="no-warp ovf-h w-full text-center text-[12px] md:text-[14px]">
                {{ item.title }}
              </div>
            </div>
          </div>
        </div>
        <van-icon
          size="12px"
          name="clear"
          class="bg-[#fff] van-icon van-icon-cross dialog-close-icon"
          @click="handelClose"
        />
      </div>
    </div>
  </van-overlay>
</template>

<script setup>
import { ref, onMounted } from 'vue'
// const { ref, onMounted } = window.Vue
import { showToast } from 'vant'
const props = defineProps({
  applist: {
    type: Array,
    default: () => []
  }
})
onMounted(() => {})
const handleDownload = () => {
  // 在这里可以编写下载二维码的逻辑
  // 例如使用一个隐藏的<a>标签，并设置其下载属性和链接地址
  let qrCodeSrc = document.getElementById('qrCodeDom').src
  // console.log(qrCodeSrc)
  const link = document.createElement('a')
  link.href = qrCodeSrc
  link.download = props.obj.web_name
  link.click()
}

const handelClose = () => {
  sessionStorage.setItem('pop_up', false)
  show.value = false
}
// const textToCopy = ref('这是要复制的文本');
const copied = ref(false)

const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text)
    showToast('复制成功')
  } catch (err) {
    // 降级方案：创建一个临时textarea元素
    const textarea = document.createElement('textarea')
    textarea.value = text
    document.body.appendChild(textarea)
    textarea.select()
    document.execCommand('copy')
    showToast('复制成功')
    document.body.removeChild(textarea)
  }
}
const handelUrl = (item) => {
  window.open(item.href, '_blank')
}

const show = ref(false)
const handelShow = () => {
  show.value = !show.value
}
const handelvideoShow = () => {
  const tc = sessionStorage.getItem('tc')
  if (tc) {
    show.value = false
  } else {
    sessionStorage.setItem('tc', true)
    show.value = true
  }
}
defineExpose({
  handelShow,
  handelvideoShow
})
</script>

<style scoped>
.bor {
  border: 1px solid #ccc;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.dialog-notice {
  width: 88%;
  max-width: 25rem;
  background: none;
}
.dialog-main {
  position: relative;
  /* max-height: 100%; */

  z-index: 2;
}
.dialog-notice .purple-notice {
  padding-bottom: 0.9375rem;
  /* background-color: #eff0f5; */
  position: relative;
  border-radius: 0.625rem;
  /* overflow: hidden; */
}
.dialog-notice .purple-notice .purple-notice-header {
  padding: 1.5625rem 1.25rem 0.3125rem;
  color: #673ab7;
  background: linear-gradient(#673ab7, #eff0f5, 70%, #eff0f5);
  border-radius: 0.625rem;
}
.dialog-notice .purple-notice .purple-notice-header h3 {
  margin: 0;
  line-height: 1.5rem;
  font-size: 1.25rem;
  font-weight: 700;
  text-align: center;
}
.dialog-notice .purple-notice .purple-notice-header h3 span {
  margin-left: 0.125rem;
  font-size: 0.875rem;
}
.dialog-notice .purple-notice .purple-notice-content {
  margin: 0.625rem 0.9375rem 0;
  background-color: #fff;
  border-radius: 0.625rem;
  /* overflow: hidden; */
}
.dialog-notice .purple-notice .purple-notice-content .scroll-wrapper {
  /* max-height: 18.75rem; */
}
.scroll-wrapper {
  /* overflow: hidden !important; */
  padding: 0 !important;
  position: relative;
}
.scroll-wrapper > .scroll-content {
  display: inline-block;
  /* white-space: wrap; */
  animation: scroll 10s linear infinite;
  border: none !important;
  box-sizing: content-box !important;
  /* height: auto; */
  left: 0;
  margin: 0;
  /* max-height: none; */
  max-width: none !important;
  /* overflow: scroll !important; */
  padding: 0;
  position: relative !important;
  top: 0;
  width: auto !important;
}
.dialog-notice .purple-notice .purple-notice-content .purple-notice-content-scrollbar {
  box-sizing: border-box;
  padding: 0.9375rem 1.25rem;
  color: #673ab7;
}
.dialog-notice .purple-notice .purple-notice-content .site-qrcode {
  /* margin: 0.5rem 0 0.625rem 0.9375rem; */
  float: right;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
}
a,
a:hover,
a:active,
a:focus {
  color: #333;
  text-decoration: none;
}
.dialog-notice .purple-notice .purple-notice-content .site-qrcode #qrcode canvas {
  width: 4.5rem;
  height: 4.5rem;
}
.dialog-notice .purple-notice .purple-notice-content .site-qrcode p {
  font-size: 14px;
  font-weight: 700;
}
.dialog-notice .purple-notice .purple-notice-content .purple-notice-content-scrollbar p {
  margin-bottom: 0.375rem;
  line-height: 1.6;
  /* word-wrap: break-word; */
  white-space: normal; /* 确保可以自动换行 */
  font-size: 14px;
  max-width: 100%;
}
p {
  margin: 0 0 10px;
}
.dialog-notice .purple-notice .purple-notice-content .purple-notice-content-scrollbar p {
  /* margin-bottom: 0.275rem;
  line-height: 1.6;
  word-wrap: break-word; */
}
.btn-normal {
  color: #fff;
  background-color: #673ab7;
  border-color: #673ab7;
}
.dialog-notice .purple-notice .purple-notice-tip {
  margin: 0.625rem 0.9375rem 0;
  padding: 0.25rem 0.9375rem;
  color: #673ab7;
  font-weight: 700;
  text-align: center;
  border: 0.125rem solid #673ab7;
  border-radius: 0.25rem;
}
.dialog .dialog-close-icon {
  color: #c8c9cc;
  font-size: 1.375rem;
  position: absolute;
  top: 0.9375rem;
  right: 0.9375rem;
  z-index: 1;
  cursor: pointer;
}
.van-icon {
  position: relative;
  display: inline-block;
  font: normal normal normal 14px / 1 vant-icon;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
}
.dialog-notice .dialog-close-icon {
  width: 1.5rem;
  height: 1.5rem;
  background-color: rgba(0, 0, 0, 0.75);
  color: #fff;
  border-radius: 50%;
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 0.5rem;
  top: 0.5rem;
}
.btn {
  width: 90%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn {
  display: inline-block;
  margin-bottom: 0;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  background-image: none;
  border: 1px solid transparent;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  border-radius: 4px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.no-style {
  text-decoration: none; /* 去掉下划线 */
  color: #fff; /* 继承父元素的字体颜色 */
}

.no-style:focus,
.no-style:active {
  outline: none; /* 去掉焦点时的轮廓 */
  background: #673ab7; /* 去掉点击时的背景色 */
}
</style>
